module.exports = function transitionEnd() {
    var el = document.createElement('div')

    var transEndEventNames = {
        WebkitTransition : 'webkitTransitionEnd',
        MozTransition    : 'transitionend',
        OTransition      : 'oTransitionEnd otransitionend',
        transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
        if (el.style[name] !== undefined) {
            return transEndEventNames[name];
        }
    }

    return false
}


// WEBPACK FOOTER //
// ./core/xhr2/transitionEnd.js